import { useEffect, useRef, useState } from 'react';
import { MapStyleDataEvent } from 'mapbox-gl';

import { useMap } from './useMap';

export const useMapStyle = () => {
  const map = useMap();
  const styleIdRef = useRef<string | null>(
    // @ts-ignore
    map?.style?.stylesheet?.name ?? null
  );
  const [styleId, setStyleId] = useState<string | null>(
    // @ts-ignore
    map?.style?.stylesheet?.name ?? null
  );

  useEffect(() => {
    const onStyleUpdate = (e: MapStyleDataEvent) => {
      // @ts-ignore
      const newStyleId = e?.style?.stylesheet?.name ?? null;

      if (styleIdRef.current !== newStyleId) {
        styleIdRef.current = newStyleId;
        setStyleId(styleIdRef.current);
      }
    };

    map?.on('styledata', onStyleUpdate);

    return () => {
      map?.off('styledata', onStyleUpdate);
    };
  }, [map]);

  return styleId;
};
